import { NavLink, useLocation } from "react-router-dom";
import { Home, Store, ShoppingCart, User2, Sprout } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { useI18n } from "../context/I18nContext";

/** App-style tab bar for phones (hidden on larger screens and on checkout, where it would crowd the pay button). */
export default function BottomNav() {
  const { user } = useAuth();
  const { count } = useCart();
  const { t } = useI18n();
  const { pathname } = useLocation();
  if (pathname.startsWith("/checkout")) return null;
  const tabs = [
    { to: "/", id: "home", label: t("nav_home"), icon: Home, end: true },
    { to: "/marketplace", id: "shop", label: t("nav_shop"), icon: Store },
    { to: "/farmers", id: "farms", label: t("nav_farms"), icon: Sprout },
    { to: "/cart", id: "cart", label: t("nav_cart"), icon: ShoppingCart, badge: count },
    { to: user ? "/account" : "/login", id: user ? "account" : "login", label: user ? t("nav_account") : t("login"), icon: User2 },
  ];
  return (
    <nav aria-label="Mobile" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-background/95 backdrop-blur border-t pb-[env(safe-area-inset-bottom)]">
      <ul className="grid grid-cols-5">
        {tabs.map(({ to, id, label, icon: Icon, end, badge }) => (
          <li key={id}>
            <NavLink to={to} end={end} data-testid={`tab-${id}`}
              className={({ isActive }) => `relative flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${isActive ? "text-primary" : "text-muted-foreground"}`}>
              <span className="relative"><Icon className="w-5 h-5" />
                {badge > 0 && <span className="absolute -top-1.5 -right-2.5 min-w-[16px] h-4 px-1 rounded-full bg-secondary text-secondary-foreground text-[10px] font-bold grid place-items-center">{badge > 99 ? "99+" : badge}</span>}
              </span>
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
